import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { TariffsPage } from '@/pages/tariffs/TariffsPage'

export const Route = createFileRoute('/tariffs/')({
  component: () => (
    <RequirePermission section="tariffs" action="view">
      <TariffsPage />
    </RequirePermission>
  ),
})
